import * as yup from 'yup';
export const CreateExhibitorFormValidation = yup.object().shape({
  idUser: yup.string().optional(),
  address: yup.string().required('Endereço é obrigatório'),
  user: yup.object().shape({
    name: yup.string().required('Nome é obrigatório'),
    userName: yup.string().required('Nome de utilizador é obrigatório'),
    email: yup.string().email('Email inválido').required('Email é obrigatório'),
    bi: yup.string().required('BI é obrigatório'),
    nuit: yup
      .string()
      .optional()
      .matches(/^\d{9}$/, {
        message: "Deve ter 9 digitos",
        excludeEmptyString: true,
      }),
    phoneNumber: yup.string().matches(/^\d{9}$/, 'Número de telemóvel inválido').required('Número de telemóvel é obrigatório'),
    dateOfBirth: yup.string().required('Data de nascimento é obrigatória')
      .test('is-date', 'Data inválida', (value) => !value || !isNaN(Date.parse(value)))
      .test('is-past', 'Data de nascimento não pode ser no futuro', (value) => !value || new Date(value) <= new Date()),
    gender: yup.string().oneOf(['M', 'F'], 'Gênero inválido').default('M').required('Gênero é obrigatório'),
  }).required(),
});
